import {
  Button,
  Col,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
  Row,
} from 'reactstrap';
import { callApi, formatDateTime } from '../../utils';

import Loading from '../Loading';
import React from 'react';
import { connect } from 'react-redux';
import { showError } from '../../actions/notificationActions';
import DataTable from '../DataTable';

class UserFeedback extends React.Component {
  state = {
    queryParams: {
      page: 1,
      limit: '30',
    },
    meta: { pages: 1 },
    loading: false,
    rows: [],
    metaModal: false,
    selectedMeta: null,
  };

  setInput = (e) => {
    const { name, value } = e.target;
    this.setState({
      queryParams: { ...this.state.queryParams, [name]: value },
    });
  };

  setPage = (page) => {
    if (page) {
      this.setState(
        { queryParams: { ...this.state.queryParams, page } },
        () => {
          this.loadFeedback();
        }
      );
    }
  };

  startLoad = () => this.setState({ loading: true });
  stopLoad = () => this.setState({ loading: false });

  showMetaModal = (meta) => {
    this.setState({ metaModal: true, selectedMeta: meta });
  };

  toggleMetaModal = () => {
    this.setState({ metaModal: !this.state.metaModal, selectedMeta: null });
  };

  loadFeedback = () => {
    const { page, limit } = this.state.queryParams;
    const id = this.props.user.id;

    this.startLoad();
    callApi(`/users/${id}/feedback`, {
      page,
      limit,
    })
      .then(({ data = [], meta = {} }) => {
        this.setState({ rows: data, meta });
      })
      .catch((err) => {
        this.props.dispatch(showError(err));
      })
      .finally(() => {
        this.stopLoad();
      });
  };

  componentWillMount() {
    this.loadFeedback();
  }

  render() {
    const { rows, loading, meta, queryParams } = this.state;
    const { page, limit } = queryParams;

    return (
      <div>
        {loading ? (
          <Loading />
        ) : (
          <>
            <Row>
              <Col md={12}>
                <DataTable
                  card={false}
                  loading={loading}
                  minWidth={900}
                  page={page}
                  total={meta.pages || 1}
                  onPageChange={this.setPage}
                >
                  <thead>
                    <tr>
                      <th>#</th>
                      <th>Date</th>
                      <th>Key</th>
                      <th>Tag</th>
                      <th>Body</th>
                      <th>Meta</th>
                    </tr>
                  </thead>
                  <tbody>
                    {rows.length > 0 ? (
                      rows.map((row, index) => (
                        <tr key={row.id || index}>
                          <td>{(page - 1) * limit + index + 1}</td>
                          <td>{formatDateTime(row.created_at)}</td>
                          <td>
                            <span className={'badge badge-secondary'}>
                              {row.key || 'N/A'}
                            </span>
                          </td>
                          <td>{row.tag || 'N/A'}</td>
                          <td>
                            <div
                              style={{
                                maxWidth: '300px',
                                whiteSpace: 'nowrap',
                                overflow: 'hidden',
                                textOverflow: 'ellipsis',
                              }}
                              title={row.body || 'N/A'}
                            >
                              {row.body || 'N/A'}
                            </div>
                          </td>
                          <td>
                            {row.meta ? (
                              <Button
                                size="sm"
                                color="info"
                                onClick={() => this.showMetaModal(row.meta)}
                              >
                                View ({Object.keys(row.meta).length} keys)
                              </Button>
                            ) : (
                              'N/A'
                            )}
                          </td>
                        </tr>
                      ))
                    ) : (
                      <tr>
                        <td colSpan="6" className="text-center">
                          No feedback found
                        </td>
                      </tr>
                    )}
                  </tbody>
                </DataTable>
              </Col>
            </Row>

            <Row>
              <Col md={12}></Col>
            </Row>
          </>
        )}

        <Modal
          isOpen={this.state.metaModal}
          toggle={this.toggleMetaModal}
          size="lg"
        >
          <ModalHeader toggle={this.toggleMetaModal}>
            Feedback Meta Data
          </ModalHeader>
          <ModalBody>
            {this.state.selectedMeta ? (
              <pre
                style={{
                  backgroundColor: '#f5f5f5',
                  padding: '15px',
                  borderRadius: '4px',
                  maxHeight: '500px',
                  overflow: 'auto',
                }}
              >
                {JSON.stringify(this.state.selectedMeta, null, 2)}
              </pre>
            ) : (
              <p>No meta data available</p>
            )}
          </ModalBody>
          <ModalFooter>
            <Button color="secondary" onClick={this.toggleMetaModal}>
              Close
            </Button>
          </ModalFooter>
        </Modal>
      </div>
    );
  }
}

export default connect()(UserFeedback);
